<template>
    <div></div>
</template>

<script>
    import { useToast } from "bootstrap-vue-next"

    export default {
        name: "ToastComponent", 
        setup() {
            const {create} = useToast();

            const toast = (body, props) => {
                props.body = body;
                create({props: props});
            }

            return {
                toast
            }
        },
    }
</script>
